import { useHasPermission } from "../useHasPermission";
import { HeldEmailQueueTableModel } from "../../components/admin/system-emails/heldEmailQueueTableModel";
import { HeldEmailQueueViewModel } from "../../components/admin/system-emails/heldEmailQueueViewModel";
import {
  useHeldEmailQueueActions,
  useHeldEmailQueueNavigation,
} from "./useHeldEmailQueueCallbacks";

export function useHeldEmailQueueTableModel(
  model: HeldEmailQueueViewModel
): HeldEmailQueueTableModel {
  const actions = useHeldEmailQueueActions(model.dispatch);
  const navigation = useHeldEmailQueueNavigation(model.dispatch);
  return {
    canRelease: useHasPermission("system_emails.release"),
    emails: model.data?.data ?? [],
    filtered: model.filtered,
    onCancel: actions.cancel,
    onRelease: actions.release,
    onSelectionChange: navigation.select,
    onView: navigation.view,
    selectedIds: model.state.selectedIds,
  };
}
